// extracted by mini-css-extract-plugin
export default {"form-card":"ShoolAdminTip_form-card__MayGJ","form-title":"ShoolAdminTip_form-title__SpQIM","form-actions":"ShoolAdminTip_form-actions__PcCsF"};